import { defineComponent as a, createElementBlock as r, openBlock as t, normalizeClass as o, renderSlot as l } from "vue";
const i = ["href", "aria-label"], m = /* @__PURE__ */ a({
  __name: "MsFooterLink",
  props: {
    isInline: Boolean,
    href: String,
    ariaLabel: String
  },
  setup(e) {
    return (n, s) => (t(), r("a", {
      class: o(["block mb-16 mr-24 transition-colors duration-200 screen-m:mr-16 text-text-l hover:underline ease-ms", { inline: e.isInline }]),
      "data-component": "MsFooterLink",
      href: e.href,
      target: "_blank",
      "aria-label": e.ariaLabel
    }, [
      l(n.$slots, "default")
    ], 10, i));
  }
});
export {
  m as default
};
